const HOME_STORAGE_PREFIX = 'homeScroll:home:all';
const HOME_AUTH_SIG_KEY = 'homeScroll:authSig';

export function getAuthSignature(userInfo) {
  if (!userInfo) return 'anon';
  return String(userInfo._id || userInfo.id || userInfo.email || userInfo.username || 'user');
}

export function clearHomeRestoreState() {
  try {
    const ss = window.sessionStorage;
    const keysToRemove = [];
    for (let i = 0; i < ss.length; i++) {
      const k = ss.key(i);
      if (!k) continue;
      if (k === HOME_AUTH_SIG_KEY) keysToRemove.push(k);
      if (k.startsWith(`${HOME_STORAGE_PREFIX}:`)) keysToRemove.push(k);
      if (k.startsWith('homeScreen')) keysToRemove.push(k);
    }
    for (const k of keysToRemove) ss.removeItem(k);
  } catch (_) {}

  try {
    const cacheKey = '__PROSHOP_HOME_RESTORE__';
    if (typeof window !== 'undefined' && window[cacheKey]) delete window[cacheKey];
  } catch (_) {}
}

export function setHomeAuthSignature(sig) {
  try {
    window.sessionStorage.setItem(HOME_AUTH_SIG_KEY, String(sig || 'anon'));
  } catch (_) {}
}

export function getHomeAuthSignature() {
  try {
    return window.sessionStorage.getItem(HOME_AUTH_SIG_KEY);
  } catch (_) {
    return null;
  }
}

export function isHardReloadNavigation() {
  try {
    const navEntries = performance.getEntriesByType?.('navigation');
    const type = navEntries && navEntries[0] && navEntries[0].type;
    if (type === 'reload') return true;
  } catch (_) {}

  // Deprecated fallback
  try {
    if (performance.navigation && performance.navigation.type === 1) return true;
  } catch (_) {}

  return false;
}
